import { useMemo } from 'react';
import { sanitizeRichText, isRichTextEmpty } from './sanitizeRichText';
import './RichTextEditor.css';

export interface RichTextContentProps {
  html: string | null | undefined;
  variant?: 'default' | 'embed' | 'onboarding';
  className?: string;
  emptyFallback?: React.ReactNode;
}

/**
 * Rend du contenu formaté (HTML) après sanitisation.
 * Défense en profondeur : le contenu est aussi sanitisé à la sauvegarde,
 * mais on ré-applique la sanitisation ici avant d'utiliser
 * `dangerouslySetInnerHTML`.
 */
export function RichTextContent({
  html,
  variant = 'default',
  className,
  emptyFallback = null,
}: RichTextContentProps) {
  const sanitized = useMemo(() => sanitizeRichText(html), [html]);

  if (isRichTextEmpty(sanitized)) {
    return <>{emptyFallback}</>;
  }

  return (
    <div
      className={`rte-content rte-content--${variant}${className ? ` ${className}` : ''}`}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
}
